module.exports = __webpack_public_path__ + "img/shiyuanhui big (1).26e6ee13.jpg";